import { fetchWithRetry } from './fetch-with-retry';

export async function fetchAllTypes() {
  try {
    const res = await fetchWithRetry(
      `${process.env.NEXT_PUBLIC_STRAPI_URL}/api/types`,
    );
    if (!res.ok) {
      throw new Error('Failed to fetch content hub items');
    }
    const data = await res.json();
    return data.data || [];
  } catch (error) {
    console.error('Error fetching content hub items:', error);
    return [];
  }
}
